import { useRef, useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Headers from './Headers'
import '../App.css'
import {
  faCheck,
  faTimes,
  faInfoCircle
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Axios from '../api/axios'

//const USER_REGEX = /^[a-zAZ][a-zA-Z0-9_]{3,23}$/;
const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/
const PHONE_REGEX =
  /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/
const EMAIL_REGEX = /^[^@]+@[^@]+\.[^@]{2,4}$/

const RegisterProducts = () => {
  let navigate = useNavigate()
  const firstUserLoggedInSessionExpired = localStorage.getItem('loggedIn')
  let secondUserLoggedInSessionExpired = JSON.parse(
    firstUserLoggedInSessionExpired
  )
  useEffect(() => {
    if (secondUserLoggedInSessionExpired === 'No') {
      navigate('/Logout')
    }
  }, [])

  const server_app_api = window.SERVER_APP_API
  const server_app_api_php = window.SERVER_APP_API_PHP

  const businessNameRef = useRef()
  const errRef = useRef()

  //const [logo, setLogo] = useState('');
  //const [pacraCertificate, setPacraCertificate] = useState('');

  const [businessName, setBusinessName] = useState('')
  const [productName, setProductName] = useState('')
  const [ip, setIP] = useState('')
  //const [userID,setUserID] = useState(userIDInitial);
  const [businessNameDropDown, setBusinessNameDropDown] = useState([])

  let [handleSubmitBtn, setHandleSubmitBtn] = useState('')
  //const [success, setSuccess ] = useState(false);

  useEffect(() => {
    businessNameRef.current.focus()
  }, [])

  /*useEffect( () => {
	alert("we are in drops");
},
[businessNameDropDown])*/

  //creating function to load ip address from the API
  const getData = async () => {
    const res = await Axios.get('https://geolocation-db.com/json/')
    console.log(res.data)
    setIP(res.data.IPv4)
  }
  useEffect(() => {
    //passing getData method to the lifecycle method
    getData()
  }, [])

  /*useEffect( () => {
        Axios.post("http://localhost:3001/api/getBusinessNameDropDown").then((response) => {
            setBusinessNameDropDown(response.data);
            //console.log(response);
            });
        },
        [])*/
  const firstSystemSetupID = localStorage.getItem('systemSetupID')
  const systemSetupIDInitial = JSON.parse(firstSystemSetupID)
  //alert("id = "+systemSetupIDInitial);

  useEffect(() => {
    /*Axios.post(`${server_app_api}/api/getBusinessNameDropDown`, {
      businessNameID: systemSetupIDInitial
    })*/
    var formDataViewBusinesses = new FormData(this)
    formDataViewBusinesses.append('apiType', 'getViewBusinesses')
    formDataViewBusinesses.append('businessNameID', systemSetupIDInitial)
    Axios({
      method: 'post',
      url: `${server_app_api_php}/reactphp/index.php`,
      data: formDataViewBusinesses,
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(response => {
      setBusinessNameDropDown(response.data)
    }) //.catch((err) => alert("ERROR : Check Your Network Connection"));
  }, [])

  const handleSubmit = async e => {
    //alert("businessName = "+businessName);
    const currentDate = new Date()
    const dateToday = `${currentDate.getDate()}/${
      currentDate.getMonth() + 1
    }/${currentDate.getFullYear()}`
    const timeNow =
      currentDate.getHours() +
      ':' +
      currentDate.getMinutes() +
      ':' +
      currentDate.getSeconds()

    const firstUserID = localStorage.getItem('userID')
    const userIDInitial = JSON.parse(firstUserID)
    var userID = userIDInitial
    /*Axios.post(`${server_app_api}/api/insertRegisterProducts`, {
      businessName: businessName,
      productName: productName,
      userID: userID,
      system_setup_IP: ip,
      dateToday: dateToday,
      timeNow: timeNow
    })*/

    setHandleSubmitBtn('Loading');
    var formDataRegisterProducts = new FormData(this)
    formDataRegisterProducts.append('apiType', 'insertRegisterProducts')
    formDataRegisterProducts.append('businessName', businessName)
    formDataRegisterProducts.append('productName', productName)
    formDataRegisterProducts.append('userID', userID)
    formDataRegisterProducts.append('system_setup_IP', ip)
    formDataRegisterProducts.append('dateToday', dateToday)
    formDataRegisterProducts.append('timeNow', timeNow)
    Axios({
      method: 'post',
      url: `${server_app_api_php}/reactphp/index.php`,
      data: formDataRegisterProducts,
      headers: { 'Content-Type': 'multipart/form-data' }
    })
      .then(res => {
        setHandleSubmitBtn('')
        setProductName('')
        setBusinessName('')
        alert(res.data)
      })
      .catch(err =>{ alert('ERROR : Kindly Contact Your Adminitrator')
      setHandleSubmitBtn('')
    })
  }

  // date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate(); //output= 2020-5-24
  //var time = new Date().toTimeString();

  //const time = `${currentDate.getTime()}`;
  //var today = new Date(),
  //alert("Time Is = "+timeNow+" Today's Date = "+date);

  ;(function () {
    var preloader = function () {
      var loader = document.querySelector('.loader')
      var overlay = document.getElementById('overlayer')

      function fadeOut (el) {
        el.style.opacity = 1
        ;(function fade () {
          if ((el.style.opacity -= 0.1) < 0) {
            el.style.display = 'none'
          } else {
            requestAnimationFrame(fade)
          }
        })()
      }

      setTimeout(function () {
        fadeOut(loader)
        fadeOut(overlay)
      }, 200)
    }
    preloader()
  })()

  let systemSetupBranchIDStoreName = localStorage.getItem(
    'systemSetupBranchIDStoreName'
  )
  systemSetupBranchIDStoreName = JSON.parse(systemSetupBranchIDStoreName)

  return (
    <>
      <title>
        KANCH INNOVATIVE TECHNOLOGIES - Register Business Product -{' '}
        {systemSetupBranchIDStoreName}{' '}
      </title>
      <>
        <Headers />
      </>

      {/*<!-- Preloader 
      <div id='overlayer'></div>
      <div class='loader'>
        <div class='spinner-border' role='status'>
          <span class='visually-hidden'>Loading...</span>
        </div>
      </div>-->*/}

      <main>
        {/*<form method="POST" encType="multipart/form-data">*/}
        <div class='container-fluid'>
          <div class='row mt-5'>
            <div class='col-md-12 mb-2'>
              <div class='card'>
                <div class='card-body'>
                  <div class='form-header white-text ocean blue-gradient'>
                    {' '}
                    REGISTER PRODUCTS HERE{' '}
                  </div>
                  {/*Start Of Row 1*/}
                  <div class='row'>
                    <div class='col-lg-6 col-md-12 mb-1'>
                      <div class='md-form'>
                        <label>
                          Business Name <i class='red-text'>*</i>{' '}
                        </label>
                        <br />
                        <br />
                        <select
                          class='custom-select d-block w-100'
                          id='businessName'
                          onChange={e => setBusinessName(e.target.value)}
                          autoComplete='off'
                          required
                          ref={businessNameRef}
                          value={businessName}
                        >
                          <option value=''>..Choose..</option>
                          {businessNameDropDown.map(val => {
                            return (
                              <option value={val.system_setupID}>
                                {val.organisation}{' '}
                              </option>
                            )
                          })}
                        </select>
                      </div>
                    </div>

                    <div class='col-lg-6 col-md-12 mb-1'>
                      <div class='md-form'>
                        <label>
                          Product Name <i class='red-text'>*</i>{' '}
                        </label>
                        <br />
                        <input
                          type='text'
                          class='form-control'
                          id='productName'
                          onChange={e => setProductName(e.target.value)}
                          autoComplete='off'
                          value={productName}
                          required
                        />
                      </div>
                    </div>
                  </div>{' '}
                  {/*End Of Row 1*/}
                  <p>
                    <span class='red-text'>* Required</span>{' '}
                    <span>- Do not leave Blank</span>
                  </p>
                  <hr class='mb-1' />
                  <button
                    onClick={handleSubmit}
                    class='btn btn-primary'
                    disabled={businessName === '' || productName === '' || handleSubmitBtn === 'Loading'}
                  >

<div class="spinner-border" role="status" hidden = {handleSubmitBtn === ''}>
</div>
                    Submit
                  </button>
                  <br /> <br /> <br />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*</form>*/}
      </main>
    </>
  )
}

export default RegisterProducts
